import React, { useEffect, useState } from 'react';
import Popup from '../../../components/Popup';
import PopupBg from '../../../assets/image/popup-bg.webp';
import PopupImg1 from '../../../assets/image/popup-img-1.png';
import PopupImg2 from '../../../assets/image/popup-img-2.png';
import PopupImg3 from '../../../assets/image/popup-img-3.webp';
import PopupImg4 from '../../../assets/image/popup-img-4.webp';
import PopupImg5 from '../../../assets/image/popup-img-5.webp';
import PopupImg6 from '../../../assets/image/popup-img-6.webp';
import PopupImgX from '../../../assets/image/popup-img-X.png';
import HomeComp from '../../../components/home/index';
import HotGames from '../../../components/home/HotGames';
import OurGames from '../../../components/home/OurGames';
import HowItWorks from '../../../components/home/HowItWorks';
import Testimonials from '../../../components/home/Testimonials';
import JoinToday from '../../../components/home/JoinToday';
import OurPlatform from '../../../components/home/OurPlatform';
import PlayingNow from './PlayingNow';
import AboutUs from '../../../components/home/AboutUs';
import Spinner from '../../../assets/image/wheel-icon.png';
import { useNavigate } from 'react-router-dom';

const Home = () => {
  const [isPopupVisible, setPopupVisible] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    setPopupVisible(true);
  }, []);

  const handleClosePopup = () => {
    setPopupVisible(false);
  };

  const images = [PopupImg1, PopupImg2, PopupImg3, PopupImg4, PopupImg5, PopupImg6, PopupImgX];

  return (
    <div className='relative'>
      <Popup
        isVisible={isPopupVisible}
        onClose={handleClosePopup}
        images={images}
        bgImg={PopupBg}
      />

      <HomeComp />
      <PlayingNow />
      <HotGames />
      <OurGames />
      <OurPlatform />
      <HowItWorks />
      <Testimonials />
      <JoinToday />
      <AboutUs />
      <div className='spinner cursor-pointer' onClick={() => {
        navigate('/wheel');
      }}>
        <img src={Spinner} alt="Spinner" className='w-full' />
      </div>
    </div>
  );
};

export default Home;
